import i18next from 'i18next';
import I18NextHttpBackend from 'i18next-http-backend';
import I18NextBrowserLanguageDetector from 'i18next-browser-languagedetector';

export async function initI18Next() {
    const defaultLanguage = 'de';

    await i18next
        .use(I18NextHttpBackend)
        .use(
            new I18NextBrowserLanguageDetector(null, {
                order: ['cookie'], // Nur das Cookie lesen
                lookupCookie: 'bahf_lang', // Nutzt das `bahf_lang`-Cookie
                caches: [], // Sprache wird nur gelesen, nicht gespeichert
            })
        )
        .init({
            fallbackLng: defaultLanguage,
            debug: false,
            supportedLngs: ['de', 'en', 'es'],
            load: 'currentOnly',
            interpolation: { escapeValue: false },
            backend: {
                loadPath: 'assets/locales/translation_{{lng}}.json',
            },
        });

    console.log(`i18next initialized with language: ${i18next.language}`);
}